module.exports = __webpack_public_path__ + "img/TRX.3ab2b6d5.png";